var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecipes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.5V20.5C27 17.5826 25.8411 14.7847 23.7782 12.7218C21.7153 10.6589 18.9174 9.5 16 9.5C13.0826 9.5 10.2847 10.6589 8.22183 12.7218C6.15893 14.7847 5 17.5826 5 20.5V21.5",
    fill: "#D2D1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.5V20.5C27 17.5826 25.8411 14.7847 23.7782 12.7218C21.7153 10.6589 18.9174 9.5 16 9.5C13.0826 9.5 10.2847 10.6589 8.22183 12.7218C6.15893 14.7847 5 17.5826 5 20.5V21.5",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21.5H3L3.64 23.64C3.88593 24.4671 4.39275 25.1926 5.08482 25.708C5.77688 26.2234 6.61708 26.5013 7.48 26.5H24.52C25.3829 26.5013 26.2231 26.2234 26.9152 25.708C27.6072 25.1926 28.1141 24.4671 28.36 23.64L29 21.5Z",
    fill: "#D2D1D1",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.5V5.5",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipes);
export default __webpack_public_path__ + "static/media/recipes.459d735d7e634ec91fd21b7cc3ac7541.svg";
export { ForwardRef as ReactComponent };